module.exports = "pegasus/assets/theme6/medium/9.jpg";